import React, { useEffect, useRef, useState } from 'react';
import { Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap';
import classes from './Templates.module.scss';
import { boxiYellow, boxiPrimary } from '../../../../assets/style/colors';
import axios from 'axios';
import { Button, Dialog, Divider, List, ListItem, ListItemButton, ListItemText, TextField, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { LoadingButton } from '@mui/lab';
import InfiniteScroll from 'react-infinite-scroll-component';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import _ from 'lodash';

const Templates = ({ isModalOpen, openModal, type, setTemplateForMessage }) => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [templateNameValue, setTemplateNameValue] = useState('');
  const [templateBodyValue, setTemplateBodyValue] = useState('');
  const [isTemplateSaving, setIsTemplateSaving] = useState(false);

  const [isTemplateLoading, setIsTemplateLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const [isEditModeOn, setEditModeOn] = useState(false);
  const [templateToEdit, setTemplateToEdit] = useState(null);
  const [templateToEditName, setTemplateToEditName] = useState('');
  const [templateToEditBody, setTemplateToEditBody] = useState('');
  const [isTemplateUpdating, setIsTemplateUpdating] = useState(false);

  const [templateToDelete, setTemplateToDelete] = useState(null);
  const [isDeleteAlertOn, setIsDeleteAlertOn] = useState(false);
  const [isTemplateDeleting, setIsTemplateDeleting] = useState(false);

  const [currentPage, setCurrentPage] = useState(-1);
  const [totalTemplates, setTotalTemplates] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [templatePagesFetched, setTemplatePagesFetched] = useState([]);

  const [templateSearchValue, setTemplateSearchValue] = useState(null);
  const [isTemplateSearchOn, setIsTemplateSearchOn] = useState(false)

  const templateListRef = useRef(null);
  
  useEffect(() => {
    const debouncedHandler = _.debounce(value => {
      if (value || value === '') {
        setCurrentPage(0);
        setIsTemplateSearchOn(true);
      }
    }, 1500);

    debouncedHandler(templateSearchValue);

    return () => {
      debouncedHandler.cancel();
    };
  }, [templateSearchValue]);

  useEffect(() => {
    if (isModalOpen) setCurrentPage(0);

    return () => {
      setTemplates([]);
      setTotalTemplates(0);
      setCurrentPage(-1);
      setHasMore(true);
      setSelectedTemplate(null);
    }
  }, [isModalOpen])

  useEffect(() => {
    if (currentPage !== -1) {
      fetchTemplates(currentPage);
    }
  }, [currentPage])

  useEffect(() => {
    if (isTemplateSearchOn) fetchTemplates(0)
  }, [isTemplateSearchOn])

  const fetchTemplates = async (page) => {
    try {
      // setIsTemplateLoading(true);
      const params = { page: page }
      if (templateSearchValue !== '') params['keyword'] = templateSearchValue
      let tempTemplates = _.cloneDeep(templates)
      if (isTemplateSearchOn) tempTemplates = []
      if (page === 0) {
        setIsTemplateLoading(true);
        tempTemplates = []
        setHasMore(false);
      }
      const res = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/templates`, { params });
      tempTemplates = [...tempTemplates, ...res.data.templates]
      setTemplates(tempTemplates);
      setTotalTemplates(+res.data.totalTemplates)
      tempTemplates.length === +res.data.totalTemplates ? setHasMore(false) : setHasMore(true)
      setIsTemplateLoading(false);
      setIsTemplateSearchOn(false);
      const temp = templatePagesFetched
      temp.push(page)
      setTemplatePagesFetched(temp)
    } catch (error) {
      setIsTemplateLoading(false);
    }
  }

  const saveTemplate = async () => {
    try {
      if (templateNameValue.length > 0 && templateBodyValue.length > 0) {
        setIsTemplateSaving(true);
        const res = await axios.post(`${process.env.REACT_APP_API_HOST}/communication/save-template`, { template_name: templateNameValue, template_body: templateBodyValue, template_created_by: JSON.parse(localStorage.getItem("userId")) })
        setIsTemplateSaving(false);
        setCurrentPage(0);
        closeAddNewModal();
        await fetchTemplates(0);
      }
    } catch (error) {
      setIsTemplateSaving(false);
      console.log(error);
    }
  }

  const selectTemplate = (template) => {
    setSelectedTemplate(template); 
    setEditModeOn(false);
    setTemplateToEdit(null);
    setTemplateToEditName('');
    setTemplateToEditBody('');
  }

  const closeTemplatesModal = () => {
    setTemplates([]);
    setSelectedTemplate(null);
    openModal(false);
  }

  const closeAddNewModal = () => {
    setTemplateNameValue('');
    setTemplateBodyValue('');
    setIsAddModalOpen(false);
  }

  const openEditMode = (template) => {
    setEditModeOn(true);
    setTemplateToEdit(template);
    setTemplateToEditName(template.template_name);
    setTemplateToEditBody(template.template_body);
  }

  const updateTemplate = async (e) => {
    e.preventDefault();

    if (templateToEditName.length > 0 && templateToEditBody.length > 0) {
      try {
        setIsTemplateUpdating(true);
        const res = await axios.patch(`${process.env.REACT_APP_API_HOST}/communication/update-template/${templateToEdit.id}`, { template_name: templateToEditName, template_body: templateToEditBody });
        setIsTemplateUpdating(false);
        setEditModeOn(false);
        setCurrentPage(0);
        setSelectedTemplate(null);
        await fetchTemplates(0);
      } catch (error) {
        setIsTemplateUpdating(false);
        console.log(error);
      }
    }
  }

  const deleteTemplate = async () => {
    try {
      setIsTemplateDeleting(true);
      if (selectedTemplate?.id === templateToDelete.id) setSelectedTemplate(null)
      const res = await axios.delete(`${process.env.REACT_APP_API_HOST}/communication/delete-template/${templateToDelete.id}`);
      setIsTemplateDeleting(false);
      setIsDeleteAlertOn(false);
      setCurrentPage(0);
      await fetchTemplates(0);
    } catch (error) {
      setIsTemplateDeleting(false);
      console.log(error);
    }
  }

  const fetchMoreData = () => {
    setCurrentPage(prevPage => prevPage + 1);
  }

  const selectTemplateToUseForMessage = () => {
    setTemplateForMessage(selectedTemplate);
    setTemplates([]);
    setSelectedTemplate(null);
    openModal(false);
  }

  const duplicateTemplate = async (template) => {
    try {
      setIsTemplateSaving(true);
      const res = await axios.post(`${process.env.REACT_APP_API_HOST}/communication/save-template`, { template_name: template.template_name + ' - Copy', template_body: template.template_body, template_created_by: JSON.parse(localStorage.getItem("userId")) });
      setIsTemplateSaving(false);
      setCurrentPage(0);
      await fetchTemplates(0);
    } catch (error) {
      setIsTemplateSaving(false);
      console.log(error);
    }
  }

  return (
    <>
      <Modal backdrop="static" className="composeModal" isOpen={isModalOpen} toggle={() => closeTemplatesModal()}>
        <ModalHeader toggle={() => closeTemplatesModal()}>Templates</ModalHeader>
        <ModalBody style={{ paddingTop: 0, paddingBottom: 0, minHeight: 360, maxHeight: 360 }}>
          {isTemplateLoading ?
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 100 }}>
              <Spinner style={{ color: boxiPrimary }} />
            </div>
            :
            <Row style={{ maxHeight: 'inherit', minHeight: 'inherit' }}>
              <Col sm="4" id="infinite-scroll-container" style={{ padding: 0, borderRight: '1px solid #ccc', maxHeight: 'inherit', minHeight: 'inherit', overflow: 'auto' }}>
                <div style={{ position: 'relative' }}>
                    <TextField
                      id="template-search"
                      type='search'
                      label="Search Template"
                      value={templateSearchValue}
                      onChange={(e) => setTemplateSearchValue(e.target.value)}
                      variant="standard"
                      className="MuiTextField-standard-shrinked"
                    />
                    {isTemplateSearchOn && <div style={{ position: 'absolute', bottom: 4, right: 35 }}><Spinner size='sm' style={{ color: boxiPrimary }} /></div>}
                  </div>
                <List sx={{ width: '100%', paddingTop: '4px', paddingBottom: '4px' }} component="nav" aria-label="vendor-options">
                  <InfiniteScroll
                    dataLength={templates.length}
                    next={fetchMoreData}
                    hasMore={hasMore}
                    loader={hasMore && <div style={{ margin: '10px auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spinner size='sm' style={{ color: boxiPrimary }} /></div>}
                    height={300}
                  >
                    {templates && templates.length > 0 && templates.map((template, index) => (
                      <>
                        <ListItemButton selected={template.id === selectedTemplate?.id} sx={{ columnGap: '10px', cursor: 'pointer', }}>
                          <Tooltip placement="top" title={template.template_name}>
                            <ListItemText disableTypography={true} sx={{ fontFamily: 'Poppins', fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} onClick={() => selectTemplate(template)} primary={template.template_name} />
                          </Tooltip>
                          {type !== 'selection' &&
                            <>
                              <EditIcon onClick={() => openEditMode(template)} fontSize='16' color='primary' />
                              <DeleteIcon onClick={() => { setIsDeleteAlertOn(true); setTemplateToDelete(template); }} fontSize='16' color='error' />
                              <ContentCopyIcon onClick={() => duplicateTemplate(template)} fontSize='16' color='secondary' />
                            </>
                          }
                        </ListItemButton>
                        <Divider />
                      </>
                    ))}
                  </InfiniteScroll>
                </List>
              </Col>
              <Col sm="8" style={{ maxHeight: 'inherit', minHeight: 'inherit', overflow: 'auto' }}>
                {!isEditModeOn && selectedTemplate && 
                  <div className={classes.selectedTemplateContainer}>
                    <div>Template Name: <br /><span>{selectedTemplate.template_name}</span></div>
                    <div>Template Body: <br /><span dangerouslySetInnerHTML={{__html: selectedTemplate.template_body.replace(/\n/g, '<br>')}}></span></div>
                  </div>
                }
                {isEditModeOn && <Form onSubmit={(e) => updateTemplate(e)}>
                  <div style={{ display: 'flex', flexDirection: 'column', rowGap: 20, marginTop: 10 }}>
                    <TextField
                      id="outlined-textarea"
                      label="Template Name"
                      placeholder="Enter Template Name"
                      className="templateNameInput"
                      value={templateToEditName}
                      onChange={(e) => setTemplateToEditName(e.target.value)}
                    />
                    <TextField
                      id="outlined-textarea"
                      label="Template Body"
                      placeholder="Enter Template Body (can be multiline)"
                      value={templateToEditBody}
                      onChange={(e) => setTemplateToEditBody(e.target.value)}
                      className="multilineTextarea"
                      multiline
                    />
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', columnGap: 10 }}>
                      <LoadingButton loading={isTemplateUpdating} type='submit' disabled={templateToEditName.length == 0 || templateToEditBody.length == 0 || isTemplateUpdating} color="primary">
                        Update
                      </LoadingButton>
                      <Button disabled={isTemplateUpdating} color="secondary" onClick={() => selectTemplate(templateToEdit)}>
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Form>}
              </Col>
            </Row>
          }
        </ModalBody>
        <ModalFooter>
          {type !== 'selection' ? 
            <Button color="primary" onClick={() => setIsAddModalOpen(true)}>
              Add New
            </Button>
            :
            <Button disabled={!selectedTemplate} color="primary" onClick={() => selectTemplateToUseForMessage()}>
              Use Template
            </Button>
          }
        </ModalFooter>
      </Modal>


      <Dialog onClose={() => setIsDeleteAlertOn(false)} open={isDeleteAlertOn} className="deleteAlertDialog">
        <div>This action will permanently delete this template. Are you sure you want to continue?</div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', columnGap: 10 }}>
          <LoadingButton loading={isTemplateDeleting} disabled={isTemplateDeleting} color="error" onClick={() => deleteTemplate()}>
            Delete
          </LoadingButton>
          <Button color="secondary" disabled={isTemplateDeleting} onClick={() => setIsDeleteAlertOn(false)}>
            Cancel
          </Button>
        </div>
      </Dialog>

      <Modal backdrop="static" className="composeModal" isOpen={isAddModalOpen} toggle={() => closeAddNewModal()}>
        <ModalHeader toggle={() => closeAddNewModal()}>Add New Template</ModalHeader>
        <ModalBody>
          <Form>
            <div style={{ display: 'flex', flexDirection: 'column', rowGap: 20 }}>
              <TextField
                id="outlined-textarea"
                label="Template Name"
                placeholder="Enter Template Name"
                className="templateNameInput"
                value={templateNameValue}
                onChange={(e) => setTemplateNameValue(e.target.value)}
              />
              <TextField
                id="outlined-textarea"
                label="Template Body"
                placeholder="Enter Template Body (can be multiline)"
                value={templateBodyValue}
                onChange={(e) => setTemplateBodyValue(e.target.value)}
                className="multilineTextarea"
                multiline
              />
            </div>
          </Form>
        </ModalBody>
        <ModalFooter>
          <LoadingButton loading={isTemplateSaving} disabled={isTemplateSaving || isTemplateLoading} color="primary" onClick={() => saveTemplate()}>
            Save
          </LoadingButton>
          <Button disabled={isTemplateSaving} color="secondary" onClick={() => closeAddNewModal()}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default Templates